export const walletErrorMessage = ({
    message,
    symbol,
    method,
}: {
    message?: string
    symbol?: string
    method?: string
}) => {
    if (!message) return 'Transaction Failed'

    if (
        message === 'transaction failed' &&
        (method === 'payWithSwap' || method === 'payWithV3Swap')
    ) {
        return `The transaction unfortunately did not succeed 😔 This is likely due to a significant change in the price of ${symbol}. Please try again in a few minutes.`
    }

    if (message.match(/insufficient funds/im)) {
        return `You don't have enough ${symbol} to cover this transaction`
    }

    if (message.match(/execution reverted: STF/)) {
        return `Swap failed. Please try again`
    }

    switch (message) {
        case 'execution reverted: ERC20: transfer amount exceeds balance':
            return `You don't have enough ${symbol} to cover this transaction`
        case 'MetaMask Tx Signature: User denied transaction signature.':
            return `Transaction was rejected`
        case '[ethjs-query] while formatting outputs from RPC \'{"value":{"code":-32603,"data":{"code":-32000,"message":"intrinsic gas too low"}}}\'':
            return `Not enough gas to cover transaction`
        default:
            return `Transaction failed: ${message}`
    }
}
